"use strict";
import { url } from "./init";
export default async function (bbox) {
    const response = await fetch(`${url}/notes.json?bbox=${bbox.toBBoxString()}`, {
        method: "GET"
    });
    return response.ok ? response.json() : null;
}
